import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import * as types from './types';
import { fetchCustomer, addCart, addCartCustomizable, updateCart } from '~/services/customer';
export default {
  fetchCustomer(_ref) {
    var _this = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref;
      const data = yield fetchCustomer(_this);
      commit(types.SET_CUSTOMER, data);
      commit(types.SET_CART, data);
    })();
  },

  addCart(_ref2, payload) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref2;
      const data = yield addCart(_this2, payload);
      commit(types.PUSH_CART, payload);
      let qty = data.split('|').find(a => a.includes('item_qty'));
      qty = qty ? qty.replace('item_qty:', '') : 0;
      const pdtData = {
        quantity: parseInt(qty, 10) || 0,
        reference: payload.reference
      };
      commit(types.SET_CURRENT_ITEM_QTY, pdtData);
    })();
  },

  addCartCustomizable(_ref3, payload) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref3;
      const data = yield addCartCustomizable(_this3, payload);

      if (data.success) {
        commit(types.PUSH_CART, {
          quantity: 1
        });
        commit(types.SET_CART_SUCCESS, true);
      } else {
        commit(types.SET_CART_SUCCESS, false);
      }
    })();
  },

  updateCart(_ref4, payload) {
    var _this4 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref4;
      const data = yield updateCart(_this4, payload);
      commit(types.SET_CART, {
        cart: data.cartItem
      });
      commit(types.SET_CURRENT_ITEM_QTY, payload);
    })();
  }

};